export default __webpack_public_path__ + "static/media/Redwood Bark.8f9a12fe.PNG";